/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Manufacturer
 *
 * 2 = VehicleClass
 *
 * 3 = Model
 *
 * 4 = ModelYear
 *
 * 5 = TransmissionType
 *
 * 6 = FuelType
 *
 * 7 = Variant
 *
 * 8 = Colour
 *
 * 9 = Trim
 *
 * 10 = FactoryOptions
 */
export enum CustomNewVehicleFilterType {
  Unknown = 0,
  Manufacturer = 1,
  VehicleClass = 2,
  Model = 3,
  ModelYear = 4,
  TransmissionType = 5,
  FuelType = 6,
  Variant = 7,
  Colour = 8,
  Trim = 9,
  FactoryOptions = 10,
}
